import { render, staticRenderFns } from "./searchbar.vue?vue&type=template&id=3c9d84f8&scoped=true"
import script from "./searchbar.vue?vue&type=script&lang=js"
export * from "./searchbar.vue?vue&type=script&lang=js"
import style0 from "./searchbar.vue?vue&type=style&index=0&id=3c9d84f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9d84f8",
  null
  
)

export default component.exports